import {Route, Routes, useLocation} from "react-router-dom";
import Home from "../pages/home";
import {useEffect} from "react";
import TermsCondition from "../pages/terms-condition";
import PrivacyPolicy from "../pages/privacy-policy";
import ContactUsOne from "../pages/components/contact-us1";
const ScrollToTop = () => {
    const {pathname} = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};
const AppRoutes = () => (
    <>
        <ScrollToTop />
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/terms-and-conditions" element={<TermsCondition />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/contact-us" element={<ContactUsOne />} />
        </Routes>
    </>
);
export default AppRoutes;
